"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientApi = void 0;
var axios_1 = __importDefault(require("axios"));
var new_error_1 = require("../errors/new-error");
var ClientApi = /** @class */ (function () {
    function ClientApi() {
        this.headers = {};
    }
    ClientApi.prototype.setHeaders = function (headers) {
        this.headers = headers;
    };
    ClientApi.prototype.setJwtToken = function (jwtToken) {
        localStorage.setItem("Bearer", jwtToken);
    };
    ClientApi.prototype.getJwtToken = function () {
        return "Bearer ".concat(localStorage.getItem("Bearer"));
    };
    ClientApi.prototype.postData = function (url, form) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.post(url, form, {
                                headers: this.getApiHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_1 = _a.sent();
                        throw this.getError(err_1.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.getData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(url, {
                                headers: this.getApiHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_2 = _a.sent();
                        throw this.getError(err_2.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.getDataWithHeaders = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(url, {
                                headers: this.getApiHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_3 = _a.sent();
                        throw this.getError(err_3.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.getDataWithHeadersBlobResponse = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(url, {
                                headers: this.getApiHeaders(),
                                responseType: 'blob'
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_4 = _a.sent();
                        throw this.getError(err_4.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.putData = function (url, form) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.put(url, form, {
                                headers: this.getApiHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_5 = _a.sent();
                        throw this.getError(err_5.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.patchData = function (url, form) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.patch(url, form, {
                                headers: this.getApiHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_6 = _a.sent();
                        throw this.getError(err_6.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.deleteData = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.delete(url, {
                                headers: this.getApiHeaders(),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_7 = _a.sent();
                        throw this.getError(err_7.response);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClientApi.prototype.getError = function (err) {
        if (err === null || err === void 0 ? void 0 : err.status) {
            return new new_error_1.NewError(err.status, err);
        }
        else {
            return new Error("Something went wrong.");
        }
    };
    ClientApi.prototype.getApiHeaders = function () {
        var headers = this.headers;
        if (this.getJwtToken()) {
            return __assign(__assign({}, headers), { Authorization: this.getJwtToken() });
        }
        else {
            return headers;
        }
    };
    return ClientApi;
}());
exports.ClientApi = ClientApi;
